function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Gmail = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 34 26",
  fill: "none"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_17500_13449",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "34",
    height: "26",
    children: /*#__PURE__*/_jsx("path", {
      d: "M33.6667 0.5H0.333374V25.5H33.6667V0.5Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_17500_13449)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2.60611 25.4993H7.90912V12.6207L0.333374 6.9388V23.2267C0.333374 24.4843 1.35231 25.4993 2.60611 25.4993Z",
      fill: "#4285F4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.0902 25.4993H31.3932C32.6509 25.4993 33.666 24.4805 33.666 23.2267V6.9388L26.0902 12.6207",
      fill: "#34A853"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.0902 2.77266V12.6212L33.666 6.93933V3.90903C33.666 1.09841 30.4577 -0.503853 28.2114 1.18175",
      fill: "#FBBC04"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.90991 12.6238V2.77538L17.0007 9.59357L26.0917 2.77538V12.6238L17.0007 19.442",
      fill: "#EA4335"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.333374 3.90903V6.93933L7.90912 12.6212V2.77266L5.78792 1.18175C3.53792 -0.503853 0.333374 1.09841 0.333374 3.90903Z",
      fill: "#C5221F"
    })]
  })]
}));
Gmail.displayName = 'Gmail';
//# sourceMappingURL=Gmail.js.map